/* control.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./control.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */

import { cx } from '@compiled/react';
import { getStyleProps } from '../utils';
var styles = {
  default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
  compact: "_1tkezwfg",
  invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
  focusedInvalid: "_16qsvyy1",
  disabled: "_1h6dby5v _lcxvglyw _bfhkby5v _1u6l1s3b",
  focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
  subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
  subtleFocused: "_bfhkvuon",
  none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
export var css = function css() {
  return {};
};
var Control = function Control(props) {
  var children = props.children,
    appearance = props.appearance,
    isCompact = props.isCompact,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    isInvalid = props.isInvalid,
    innerRef = props.innerRef,
    innerProps = props.innerProps,
    menuIsOpen = props.menuIsOpen,
    xcss = props.xcss;
  var _getStyleProps = getStyleProps(props, 'control', {
      control: true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }),
    css = _getStyleProps.css,
    className = _getStyleProps.className;
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: innerRef
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    ,
    className: ax([styles.default, isDisabled && styles.disabled, isInvalid && styles.invalid, isCompact && styles.compact, appearance === 'subtle' && styles.subtle, appearance === 'subtle' && isFocused && styles.subtleFocused, isFocused && styles.focused, appearance === 'none' && styles.none, cx(className, xcss, '-control')])
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    ,
    style: css
  }, innerProps, {
    "aria-disabled": isDisabled || undefined
  }), children);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Control;